import { memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { InfoBanner } from '@ui';
import { CaseTxCenterFormType } from '@lp/features/CaseOverview/components/Tabs/CaseDetails/components/EditCaseForms/EditCaseTxCenter/config';
import { NO_COORDINATOR_ID, ServiceType } from '@/api/apis/case';
import { ReallocationTxTrialWarningBanner } from './ReallocationTxTrialWarningBanner';

type CaseTxCenterBannersProps = {
  showWarningNotification?: boolean;
  serviceType?: ServiceType;
};

export const CaseTxCenterBanners = memo(
  ({ showWarningNotification = false, serviceType }: CaseTxCenterBannersProps) => {
    const { control } = useFormContext<CaseTxCenterFormType>();
    const [
      organType,
      txCenterTrialPrograms,
      reAllocationCaseTrialProgram,
      reAllocationCase,
      txCenterId,
      coordinatorId,
    ] = useWatch({
      control,
      name: [
        'organType',
        'txCenterTrialPrograms',
        'reAllocationCaseTrialProgram',
        'reAllocationCase',
        'txCenterId',
        'coordinatorId',
      ],
    });

    const isDirectAcq = serviceType === ServiceType.DirectAcquisition;
    const hasTxCenter = Boolean(txCenterId);
    const isServiceWithoutCoordinator = coordinatorId === NO_COORDINATOR_ID;

    const shouldShowNoCoordinatorBanner =
      hasTxCenter && isServiceWithoutCoordinator && !!showWarningNotification && !isDirectAcq;

    return (
      <>
        {shouldShowNoCoordinatorBanner && (
          <div className="mt-4">
            <InfoBanner iconType="warning">
              Selection of Service without TX Center Coordinator option will detach all the TX Center Coordinators from
              the case at Assigned Resources tab.
            </InfoBanner>
          </div>
        )}

        <ReallocationTxTrialWarningBanner
          organType={organType}
          txCenterTrialPrograms={txCenterTrialPrograms}
          reAllocationTrialProgram={reAllocationCaseTrialProgram}
          reAllocationCase={reAllocationCase}
        />
      </>
    );
  },
);
